import { useMemo } from 'react';
import { ReferralData, SortConfig } from '../types';

interface UseSortedDataProps {
  data: ReferralData[];
  sortConfigs: SortConfig[];
}

export const useSortedData = ({ data, sortConfigs }: UseSortedDataProps): ReferralData[] => {
  return useMemo(() => {
    if (sortConfigs.length === 0) return data;

    return [...data].sort((a, b) => {
      for (const sortConfig of sortConfigs) {
        if (sortConfig.order === 'none') continue;

        const aValue = a[sortConfig.column as keyof ReferralData];
        const bValue = b[sortConfig.column as keyof ReferralData];

        let comparison = 0;

        // For match percentage, parse as number
        if (sortConfig.column === 'matchPercentage') {
          const aNum = parseInt(String(aValue).replace('%', '')) || 0;
          const bNum = parseInt(String(bValue).replace('%', '')) || 0;
          comparison = aNum - bNum;
        }
        // For dates, parse as Date
        else if (sortConfig.column === 'dateTimestamp' || sortConfig.column === 'dob') {
          const aDate = new Date(String(aValue)).getTime();
          const bDate = new Date(String(bValue)).getTime();
          comparison = aDate - bDate;
        }
        // For strings
        else {
          comparison = String(aValue).localeCompare(String(bValue));
        }

        if (comparison !== 0) {
          return sortConfig.order === 'asc' ? comparison : -comparison;
        }
      }
      return 0;
    });
  }, [data, sortConfigs]);
};
